import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonComponent from "@components/Theme/Button/Button"
import {Translate} from "@components/Theme/Translate/Translate"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {CustomerStoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import CardsCategoryButton from "../CardsCategoryButton/CardsCategoryButton"

import styles from "./CustomerStorySmallCard.module.scss"

type Props = {
	data: CustomerStoryModuleType
	className?: string
}

const CustomerStorySmallCard = (props: Props) => {
	return (
		<Link
			className={`${styles.cardBox} ${props.className}`}
			data-testid={"CustomerStorySmallCardContainer"}
			href={props.data.link}
			rel={"noreferrer"}
		>
			<div className={styles.cardWrapper}>
				<div className={styles.additionalBox}>
					<NewResponsiveImage
						{...props.data.logo}
						containerClassName={styles.logoBox}
						imageClassName={styles.Logo}
						alt={props.data.title ?? props.data.logo?.alt}
					/>
					<div className={styles.contentBox}>
						<div className={styles.textBox}>
							<Typography
								as={"h3"}
								content={props.data.company}
								size={Size.S}
								variant={Variant.Title}
							/>
							<Typography
								content={props.data.title}
								variant={Variant.Description}
							/>
						</div>
					</div>
				</div>
				<div className={styles.additionalBoxBottom}>
					<div className={styles.additionalItem}>
						<div className={styles.additionalBottomWrapper}>
							<Typography
								className={styles.additionalTitle}
								content={
									<>
										<Translate>Industry</Translate>:
									</>
								}
								fontWeight={600}
								variant={Variant.Description}
							/>

							<CardsCategoryButton
								data={props.data.industry[0]}
								link={"customerStories"}
								modifier={"industries"}
							/>
						</div>
						<div className={styles.additionalBottomWrapper}>
							<Typography
								className={styles.additionalTitle}
								content={
									<>
										<Translate>Use Case</Translate>:
									</>
								}
								fontWeight={600}
								variant={Variant.Description}
							/>
							<CardsCategoryButton
								data={props.data.useCase[0]}
								link={"customerStories"}
								modifier={"useCases"}
							/>
						</div>
					</div>
					<div className={styles.additionalButton}>
						<object>
							<ButtonComponent buttonType={"readMore"} asLink>
								Read more
							</ButtonComponent>
						</object>
					</div>
				</div>
			</div>
		</Link>
	)
}

export default CustomerStorySmallCard
